import {memo} from "react";

export default memo(({children, hidden}) => (!hidden ? (children || null) : null));
